import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { WalletBalanceCard } from '@/components/features/wallets/WalletBalanceCard';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { useWallets } from '@/lib/hooks';
import { useNavigate } from '@tanstack/react-router';
import { ROUTES } from '@/config/routes';

export const Route = createFileRoute('/_auth/_admin/admin/wallets/')({
  component: WalletsComponent,
});

function WalletsComponent() {
  const navigate = useNavigate();
  const { balances, isLoading, isError } = useWallets();

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title="Критическая ошибка" />;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Кошельки"
        description="Управление системными кошельками и мониторинг балансов"
      />

      <div className="grid gap-6 md:grid-cols-1">
        <WalletBalanceCard
          balances={balances.data!}
          isLoading={isLoading}
        />
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <Card>
          <CardHeader>
            <CardTitle>Горячий кошелёк</CardTitle>
            <CardDescription>
              Основной кошелёк для обработки выводов
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              onClick={() => navigate({ to: ROUTES.ADMIN.HOT_WALLET })}
            >
              Подробнее
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Пул кошельков</CardTitle>
            <CardDescription>
              Пул адресов для приёма платежей
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              onClick={() => navigate({ to: ROUTES.ADMIN.POOL_WALLETS })}
            >
              Перейти к пулу
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Кошельки клиентов</CardTitle>
            <CardDescription>
              Персональные адреса по client_id
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              onClick={() => navigate({ to: ROUTES.ADMIN.CLIENT_STATIC_WALLETS })}
            >
              Просмотреть
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Заблокированные</CardTitle>
            <CardDescription>
              Кошельки, заблокированные из-за AML
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full"
              onClick={() => navigate({ to: ROUTES.ADMIN.DELETED_WALLETS })}
            >
              Просмотреть
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
